<script setup>
import { computed } from 'vue'

const props = defineProps({
    services: {
        type: Array,
        default: () => []
    }
})

// Fallback cards when no API data
const fallbackCards = [

]

// Map service title to route name
const getRouteName = (title) => {
    const routeMap = {
        'Company Profile': 'Company Profile',
        'Campaign Video': 'Campaign Video',
        'Campaign Management': 'Campaign Video',
        'Animation Video': 'Animation Video',
        'TV Commercial Video': 'TV Commercial Video'
    }
    return routeMap[title] || 'Services'
}
const slugify = (title) => {
    return title
        .toString()
        .toLowerCase()
        .trim()
        .replace(/\s+/g, '-')
        .replace(/[^\w\-]+/g, '')
        .replace(/\-\-+/g, '-')
}

const getServicePath = (service) => {
    const slug = service.slug || slugify(service.title)
    return `/services/${slug}`
}
// Use API services if available, otherwise use fallback
const cards = computed(() => {
    if (props.services.length > 0) {
        return props.services.map(service => ({
            img: service.icon || service.image || '/assets/img/icons/default.png',
            title: service.title,
            desc: service.description || '',
            routeName: getRouteName(service.title),
            path: getServicePath(service)
        }))
    }
    return fallbackCards
})
</script>

<template>
    <section class="wrapper py-8 px-8 md:px-16" style="background-color: #353435;">
        <div class="container">
            <p class="lead fs-20 lh-sm mb-3 text-white">
                By understanding brand objectives, audience behavior, and campaign goals,
            </p>

            <h3 class="display-4 mb-5 text-white">
                We craft powerful visual stories that
                <span class="outline-pill">elevate</span><br>
                brands and
                <span class="outline-pill">drive</span>
                meaningful campaigns.
            </h3>
        </div>
    </section>

    <section class="wrapper bg-black py-5">
        <div class="container">
            <div class="row g-4">
                <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6" v-for="(card, index) in cards" :key="index">
                    <div class="card radius-10 h-100 service-cards p-3">
                        <div class="d-flex align-items-center">
                            <img :src="card.img" alt="icon" class="service-icon" style="width: 4rem; height: 4rem;" />
                            <div class="flex-grow-1 ms-3">
                                <h3 class="text-secondary mb-1">{{ card.title }}</h3>
                                <p class="mb-0 text-light opacity-75">{{ card.desc }}</p>
                            </div>
                            <router-link :to="{ path: card.path }" class="ms-3 arrow-link" aria-label="link">
                                <i class="uil uil-arrow-up-right" style="font-size: 2rem;"></i>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<style>
.outline-pill {
    display: inline-block;
    padding: 0.18em 0.6em;
    margin: 0 0.15em;
    border: 2px solid #ffffff;
    border-radius: 999px;
    color: #ffffff;
    font-weight: 600;
    line-height: 1.2;
    white-space: nowrap;
}

.service-cards {
    background-color: transparent;
    border: none;
}

.service-icon {
    width: 40px;
    height: 40px;
    object-fit: contain;
    flex-shrink: 0;
}

.arrow-link i {
    color: #ff2eb2;
    transition: color 0.3s ease;
}

.arrow-link:hover i {
    color: #fff;
    /* jadi putih saat hover */
}

/* Tablet portrait 2x2 */
@media (min-width: 768px) and (max-width: 991.98px) {
    .row>.col-12.col-sm-6.col-md-6 {
        flex: 0 0 50%;
        max-width: 50%;
    }
}

/* Mobile 1 per baris */
@media (max-width: 767.98px) {
    .row>.col-12.col-sm-6.col-md-6 {
        flex: 0 0 100%;
        max-width: 100%;
    }
}
</style>
